import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { isWindowUndefined } from "@faire/web--source/common/server-side-rendering/isWindowUndefined";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import EventEmitter from "eventemitter3";
/**
 * @deprecated prefer to use `useAppEventsStore` or `withStores` instead
 */ export var AppEventsStore = function AppEventsStore() {
    "use strict";
    _class_call_check(this, AppEventsStore);
    if (isWindowUndefined()) {
        this.appEvents = {
            on: function() {},
            off: function() {},
            emit: function() {},
            removeListener: function() {},
            removeAllListeners: function() {}
        };
    } else {
        this.appEvents = new EventEmitter();
    }
} // export const useAppEventsStore = createStoreHook(AppEventsStore);
;
AppEventsStore.get = singletonGetter(AppEventsStore);
